/* Avis reçus — AI-01 (Bible §51 · ADM-10 · locked #18).
   Published reviews arrive through the authorised Google connection only.
   A negative review is never auto-drafted: it goes to human review, always.
   When the connection is not approved the screen says so and names what to
   connect — never a fake feed, never a marketing tick implying it works (L7). */
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, EmptyState, ErrorState, ListRow, Note, Pill } from '@/ui'
import { useReviews, type Review } from './api'
import { Chargement, Retour } from './parts'

const ETOILES = (n: number) => '★'.repeat(n) + '☆'.repeat(5 - n)
const TONE = { 'draft-ready': 'warn', 'human-review': 'crit', answered: 'done' } as const
const MARK = { 'draft-ready': '◔', 'human-review': '✕', answered: '✓' } as const

const FILTRES = ['Sans réponse', '★★★★★', '≤ ★★★'] as const

export default function Avis() {
  const { data, isPending, isError, refetch } = useReviews()
  const [filtre, setFiltre] = useState<string>(FILTRES[0])
  const nav = useNavigate()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger vos avis."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  const garde = (r: Review) =>
    filtre === 'Sans réponse' ? r.state !== 'answered'
      : filtre === '★★★★★' ? r.stars === 5
      : r.stars <= 3
  const liste = data.items.filter(garde)

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 860 }}>
      <Retour />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <h2 className="t-page" style={{ margin: 0 }}>Avis reçus — {data.location}</h2>
        <span className="tabs" style={{ marginLeft: 'auto' }}>
          {FILTRES.map(f => (
            <button key={f} type="button" className={'tab' + (filtre === f ? ' on' : '')}
              onClick={() => setFiltre(f)}>{f}</button>
          ))}
        </span>
        {data.googleConnected
          ? <Pill tone="ok">Google connecté</Pill>
          : <Pill tone="warn">Google non connecté</Pill>}
      </div>

      {data.items.length === 0 ? (
        <EmptyState title="Aucun avis publié pour l’instant."
          why="Les avis apparaissent ici une fois la connexion Google approuvée et un premier avis publié."
          action={<Button size="sm" variant="quiet" onClick={() => nav('/destinations/google')}>Voir la connexion Google</Button>} />
      ) : (
        <section>
          {liste.map(r => (
            <ListRow key={r.id}
              title={<>{ETOILES(r.stars)} «&nbsp;{r.quote}&nbsp;»</>}
              meta={r.author ? `${r.author} · ${r.meta}` : r.meta}
              end={<span className={'pill pill-' + TONE[r.state]}>{MARK[r.state]} {r.stateLabel}</span>} />
          ))}
        </section>
      )}

      <Note tone="candour">
        Sur les offres&nbsp;: «&nbsp;<b>Réponses IA — dès que votre connexion Google est
        approuvée</b>&nbsp;». Tant que l’accès Business Profile n’est pas accordé, la
        fonction affiche son état réel et cet onglet explique quoi connecter — jamais un
        faux flux, jamais une puce marketing qui laisse croire que ça marche déjà.
      </Note>
    </div>
  )
}
